import angular from 'angular';

class modalCgaImportComponent {
    /*@ngInject*/
    constructor($translate, CONF, logger, CommunitySvc) {
        this.$translate = $translate;
        this.CONF = CONF;
        this.CommunitySvc = CommunitySvc;
        this.logger = logger;
    }

    $onInit() {
        this.document = {};
    }


    cancel() {
        this.modalInstance.dismiss('cancel');
    }

    importCgaZip() {
        if (this.form.$valid) {
            if (!this.checkFileSize()) {
                return; // Stop execution if the file size exceeds the limit
            }
            this.CommunitySvc.uploadCgaZip(this.document, this.resolve.communityEid).then(
                result => {
                    this.modalInstance.close();
                    if (result.status === 400 && result.data) {
                        this.logger.error(result.data.message);
                    }else if((result.status === 500 && result.data) || result.status === 406){
                        this.logger.error("Le fichier zip n'est pas au format attendu")
                    }else {
                        this.logger.success("CGU importé avec succès", result)
                    }
                }
            );
        }
    }

    checkFileSize() {
        const fileSize = this.document.file.size;
        const maxSizeInBytes = 200 * 1024 * 1024; // 200MB in bytes
        if (fileSize > maxSizeInBytes) {
            this.modalInstance.close();
            this.logger.error("Le fichier importé dépasse la taille maximale autorisée de 200MB");
            return false; // File size is too large
        }
        return true; // File size is within the limit
    }


}

angular.module('app.community').component('modalCgaImportComponent', {
    templateUrl: require('./modal-cga-import.html'),
    controller: modalCgaImportComponent,
    bindings: {
        modalInstance: '<',
        resolve: '<',
    },
});
